import { AppMessages } from './../../../../shared/constants/messages';
import { DialogService } from './../../../../shared/services/dialog.service';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../../shared/services/base.service';
import { AppConstants } from '../../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { Utility } from '../../../../common/utility';
import { ValidationService } from '../../../../shared/services/validation.service';
import * as moment from 'moment';
import { ImportFormModel, Appointment } from '../../../../models/request-appointment/appointment.model';
import { ListMemberService } from '../list-member.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { log } from 'util';

@Component({
  selector: 'large-group',
  templateUrl: 'large-group.component.html',
  providers: [ListMemberService]
})
export class LargeGroupComponent implements OnInit, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();

  public appConstants = AppConstants;
  public largeGroupForm: FormGroup;
  public bookingMemberModel = new Appointment();
  public url: string;
  public logoImage: File = null;
  public fileImport: File = null;
  public fileErrorMessage = ValidationService.getValidatorErrorMessage('invalidExelFile');
  public listMemberModel = new ImportFormModel();
  public listMemberForm: FormGroup;
  public dataMembers = [];

  public minDate = new Date();
  public maxDate = new Date();
  public centreId: string;
  constructor(
    private activeRouter: ActivatedRoute,
    public utility: Utility,
    private formBuilder: FormBuilder,
    public dialogService: DialogService,
    public listMemberManageService: ListMemberService,
    private router: Router) {
    this.createForm();
  }

  ngOnInit() {
    this.drawDtTable();
    this.centreId = this.activeRouter.snapshot.params['id'] || null;

    this.listMemberManageService.getBookingCache(this.centreId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data !== null && data !== undefined) {
            this.bookingMemberModel = data;
            if (this.bookingMemberModel.listMembers.length) {
              // this.dataMembers = this.bookingMemberModel.listMembers;
              // this.bookingMemberModel.listMembers.forEach(element => {
              //   this.dataMembers.push(element);
              // });
              // update table
              this.rerender();
              //console.log('listMembers', this.bookingMemberModel.listMembers);

            }
          }
        }
      }
    );

    this.listMemberManageService.downloadFileTemplate().subscribe(
      result => {
        if (result) {
          this.url = result.url;

        } else {
          this.url = '';
        }
      }
    );
  }

  drawDtTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      lengthChange: false,
      searching: false,
      retrieve: true,
      data: this.dataMembers,

      columns: [{
        title: 'Name',
        data: 'name'
      }, {
        title: 'DOB',
        data: 'dateOfBirth',
        render: function (data, type, row) {
          return moment(data).format('DD MMM YYYY');
        }
      }, {
        title: 'Country Of Birth',
        data: 'countryOfBirth'
      }, {
        title: 'Address',
        data: 'address'
      }, {
        title: 'Mobile Phone',
        data: 'mobilePhone'
      }, {
        title: 'Country',
        data: 'country',
      }, {
        title: 'Email',
        data: 'email',
      }, {
        title: 'Occupation',
        data: 'occupation',
      }],
      language: {
        emptyTable: 'No member record',
        info: 'Total _TOTAL_ member(s)',
        infoEmpty: 'Total 0 member(s)',
        processing: '<img src="../assets/images/spinner.gif" />'
      }
    };
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  createForm() {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0);
    this.minDate.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    this.maxDate.setFullYear(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate());
    this.largeGroupForm = this.formBuilder.group({
      bookingDate: [currentDate, [Validators.required]],
      IsFileDelete: [''],
      FileName: [''],
      members: [this.dataMembers]
    });
  }

  onBookAppointment() {
     // if there are some duplicated records (same First Name, Surname and DOB), display error message
     if (this.listMemberManageService.isDuplicatePatientInList(this.dataMembers) === true) {
      this.dialogService.openErrorDialog({ message: AppMessages.booking.duplicateRecord });
      return;
    }
    const formData = new FormData();
    if (this.largeGroupForm.valid && this.dataMembers.length >= 10) {
      this.bookingMemberModel.listMembers = this.dataMembers;
      if (this.fileImport) {
        formData.append('excelFile', this.fileImport, this.fileImport.name);
      }
      this.bookingMemberModel.administeredDate = this.largeGroupForm.controls['bookingDate'].value;
      formData.append('data', JSON.stringify(this.bookingMemberModel));
      this.listMemberManageService.addBookingGroup(formData).subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.dialogService.openSuccessDialog({ message: data.message });
            this.router.navigate(['view-schedule']);
          }
        }
      );
    } else if (this.dataMembers.length < 10) {
      this.dialogService.openErrorDialog({ message: AppMessages.requestForAppointment.errorMemberLargeGroup });
    }
  }

  onBack() {
    this.bookingMemberModel.listMembers = this.dataMembers;
    this.listMemberManageService.addBookingCache(this.bookingMemberModel).subscribe(
      result => {
        if (result) {
          this.router.navigate(['/request-appointment', this.centreId]);
        }
      }
    );
  }

  /**
   * on input from date booking event
   * @param event
   */
  onBookingDateInput(event) {
    ValidationService.validationDate(this.largeGroupForm.controls['bookingDate'], event);
  }

  /**
   * on import file
   * @param event
   */
  importFile() {
    const formData = new FormData();
    this.dataMembers.splice(0, this.dataMembers.length);
    if (this.fileImport) {
      formData.append('excelFile', this.fileImport, this.fileImport.name);
    }
    this.listMemberManageService.importFileMember(formData).subscribe(
      result => {
        if (result) {
          const data = result.json();
          const data1 = data['list'];
          if (!data1) {
            this.dialogService.openErrorDialog({ message: data.message });
          } else {
            data1.forEach(element => {
              this.dataMembers.push(element);
            });

            // update table
            this.rerender();
            this.dialogService.openSuccessDialog({ message: data.message });
          }
        }
      }
    );
  }

  onRemoveFile(event) {
    // this.listMemberForm.controls['IsFileDelete'].setValue(true);
    // this.listMemberForm.controls['FileName'].setValue('');
    // this.dataMembers = [];
    this.fileImport = null;
    this.listMemberModel.fileName = '';
    // get input file and set value to null
    const fileInput = event.target.parentElement.parentElement.nextElementSibling.nextElementSibling;
    fileInput.value = '';
  }

  onChangeFlie(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (this.utility.isValidFile(file, AppConstants.uploadFileConfig.exel, 2)) {
        this.fileImport = file;
        // hide choose file button
        event.target.hidden = true;
        // this.listMemberForm.controls['IsFileDelete'].setValue(false);
        // this.listMemberForm.controls['FileName'].setValue(this.fileImport.name);
      } else {
        // show error popup
        this.dialogService.openErrorDialog({ message: this.fileErrorMessage });
      }
    }
  }

  /**
   * for Rerender table
   */
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/list-member/large-group/large-group.component.ts